import type { IconSvgObject } from './types';

const WebcamIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "10", r: "8", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.125 6.25H15M15.25 6.25C15.25 6.11193 15.1381 6 15 6C14.8619 6 14.75 6.11193 14.75 6.25C14.75 6.38807 14.8619 6.5 15 6.5C15.1381 6.5 15.25 6.38807 15.25 6.25Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "10", r: "2", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 18V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M8 22H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default WebcamIcon;
